const md5 = require('md5'); // tslint:disable-line

let FORMER_DEJAVU_FLAG: boolean = true;
const ts: number = +new Date();

// let senceId: string = md5('sence-' + ts + '');
const episodeId: string = md5('episode-' + ts + '');

function DejavuMiddleware(ctx: any, next: any): any {
    if (FORMER_DEJAVU_FLAG) {
        FORMER_DEJAVU_FLAG = false;
        ctx.defineGetter('episodeId', episodeId);
        // ctx.defineGetter('senceId', senceId);

        // if (DEJAVU_FLAG) {
        //     DEJAVU_FLAG = false;
        //     ctx.core.on('ERROR', () => {
        //         const newTime: number = +new Date();
        //         senceId = 'sence-' + md5(newTime + '');
        //         ctx.defineGetter('senceId', senceId);
        //     });
        //
        //     ctx.core.record = () => {
        //         const newTime: number = +new Date();
        //         senceId = 'sence-' + md5(newTime + '');
        //         ctx.defineGetter('senceId', senceId);
        //
        //         ctx.report({
        //             level: 'INFO',
        //             name: 'prajna-dejavu-record',
        //             content: 'start recording',
        //         });
        //     };
        //
        //     ctx.core.finish = () => {
        //         const newTime: number = +new Date();
        //         senceId = 'sence-' + md5(newTime + '');
        //         ctx.defineGetter('senceId', senceId);
        //
        //         ctx.report({
        //             level: 'INFO',
        //             name: 'prajna-dejavu-finish',
        //             content: 'finish recording',
        //         });
        //     };
        // }
    }
    next();
}

export default DejavuMiddleware;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/middleware/dejavu-middleware.ts